import { useTranslation } from 'react-i18next';
import FeatureTile, {
    FeatureTileComponent,
} from '../../FeatureTile/FeatureTile';
import { CardUiRegular } from '@fluentui/react-icons';
import { useSelector } from '../../../../store/hooks';
import { FeatureServiceKey } from '../../../../store/features/healthDashboard/healthDashboardSlice';
import { useFeatureStatus, useIssueFeatureItems } from '../../healthUtils';

const relatedServices: readonly FeatureServiceKey[] = [
    'gatwickApi',
    'heathrowApi',
    'functionApp',
    'grpcServer',
] as const;

const WelcomeCardTile: FeatureTileComponent = ({ className }) => {
    const { t } = useTranslation();

    const { healthInfo } = useSelector((x) => x.healthDashboard);

    const info = healthInfo?.flightUpdates;

    const status = useFeatureStatus(
        info && info.errorCount > 0,
        info?.lastSuccessOnUtc,
        info?.lastErrorOnUtc
    );

    const items = useIssueFeatureItems(info?.errorCount, status);

    return (
        <FeatureTile
            title={t('Health_WelcomeCard_Title')}
            icon={<CardUiRegular />}
            status={status}
            items={items}
            relatedServices={relatedServices}
            className={className}
        />
    );
};

export default WelcomeCardTile;
